module.exports = __webpack_public_path__ + "qrcode.png?6ad650cd24f009402d4ebbccfefe9a30";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point-register/qrcode.png
// module id = 995
// module chunks = 0